import { Injectable } from '@angular/core';
import { MSMapType } from 'src/app/models/map.model';
import { CONSTANTS } from 'src/app/services/config.service';
import { GeolocationPermission } from 'src/app/services/location/geolocation-permission';
import { GeolocationService } from 'src/app/services/location/geolocation.service';
import { PlatformPropertiesService } from 'src/app/services/platform-properties/platform-properties.service';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { PlatformEnum } from 'src/app/utils/platform.utils';
import { GoogleMapsConfig } from '../models/google-maps.config';
import { GoogleMapsModule } from '../modules/google-maps.module';

@Injectable({
  providedIn: GoogleMapsModule
})
export class GoogleMapConfigFactory {
  constructor(
    private geolocation: GeolocationService,
    private platformPropertiesService: PlatformPropertiesService,
    private platformService: PlatformService
  ) {}

  async create(enableCurrentLocation: boolean): Promise<GoogleMapsConfig> {
    const apiKey = await this.platformPropertiesService.getGoogleMapsApiKey();
    const permissionStatus = await this.geolocation.getPermissionsStatus();
    const hasPermission = permissionStatus === GeolocationPermission.MSPermissionStatus.GRANTED;
    const enableCurrentLocationActual = hasPermission && enableCurrentLocation;
    const padding =
      this.platformService.getPlatform() === PlatformEnum.IOS
        ? CONSTANTS.MAPS.GOOGLE_MAP_PADDING_IOS
        : CONSTANTS.MAPS.GOOGLE_MAP_PADDING_ANDROID;

    const config: GoogleMapsConfig = {
      enableCurrentLocation: enableCurrentLocationActual,
      padding,
      mapType: MSMapType.NORMAL,
      apiKey,
      pixelWidth: CONSTANTS.MAPS.GOOGLE_MAP_PIXEL_WIDTH,
      pixelHeight: CONSTANTS.MAPS.GOOGLE_MAP_PIXEL_HEIGHT,
      center: CONSTANTS.MAPS.DEFAULT_MAP_CENTER,
      zoom: CONSTANTS.MAPS.DEFAULT_MAP_ZOOM
    };

    return config;
  }
}
